/**
 * 목록 그리드의 열 규칙.
 *
 * 열 수를 브레이크포인트로 못 박지 않고 `auto-fit` 에 맡긴다 — 카드가 최소 595px 을 확보하는
 * 만큼 열이 늘어나므로, 새 해상도가 나와도 규칙을 고칠 필요가 없다.
 *
 * ⚠️ 그 대신 **열 수가 CSS 선택자에게는 보이지 않는다.** 아래 `LIST_GRID_TWO_ROW_CLAMP` 가
 * 그 값을 미디어 쿼리로 되짚는데, 두 상수는 같은 계산에서 나오므로 **반드시 함께 고친다.**
 */
const MIN_COLUMN_WIDTH_PX = 595;

/** 그리드 가로 간격(`gap-x-xs` = 8px). 열 전환 지점 계산에 들어간다. */
const COLUMN_GAP_PX = 8;

/**
 * n 열이 들어가기 시작하는 컨테이너 폭.
 *
 * `auto-fit` 이 실제로 쓰는 식과 같다 — n*최소폭 + (n-1)*간격.
 * 계산해 두는 이유는 아래 클래스 문자열의 숫자가 어디서 왔는지 남기기 위해서다.
 * Tailwind 는 런타임 값을 클래스로 못 만들어 문자열은 리터럴이어야 한다.
 */
export const listGridColumnBreakpoint = (columns: number) =>
  columns * MIN_COLUMN_WIDTH_PX + (columns - 1) * COLUMN_GAP_PX;

// 2열 1198px · 3열 1801px · 4열 2404px — 아래 리터럴과 일치해야 한다.

export const LIST_GRID_CLASSNAME =
  'grid max-tablet-sm:grid-cols-1 grid-cols-[repeat(auto-fit,minmax(595px,1fr))] gap-x-xs';

/**
 * 그리드를 **두 줄까지만** 보이게 자른다. 열이 몇이든 마지막 줄이 비어 보이지 않는다.
 *
 * 열 수 × 2 칸만 남기고 나머지는 `display:none` 이다 — 숨긴 카드는 탭 순서에서도 빠진다
 * (`visibility`/`opacity` 로 숨기면 키보드로는 도달해 버린다).
 *
 * 구간이 서로 겹치지 않아 규칙 간 우선순위 다툼이 없다. 1~2열을 한 구간으로 묶은 것은
 * 의도다 — 1열(모바일)에서 두 줄이면 폴더가 1개만 남아 지금보다 빈약해진다.
 *
 * | 폭 | 열 | 보이는 칸 |
 * |---|---|---|
 * | ~1800px | 1~2 | 4 (`새 폴더` + 3) |
 * | 1801~2403px | 3 | 6 (`새 폴더` + 5) |
 * | 2404px~ | 4 | 8 (`새 폴더` + 7) |
 */
export const LIST_GRID_TWO_ROW_CLAMP = [
  'max-[1800px]:[&>*:nth-child(n+5)]:hidden',
  'min-[1801px]:max-[2403px]:[&>*:nth-child(n+7)]:hidden',
  'min-[2404px]:[&>*:nth-child(n+9)]:hidden',
].join(' ');

/** 두 줄 규칙이 가장 넓은 화면에서 그리는 카드 수. 그만큼은 받아 둬야 빈칸이 안 생긴다. */
export const LIST_GRID_TWO_ROW_MAX_CELLS = 8;
